import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import { SectionContainer } from '../styles/LandingStyles';
import Layout from '../components/layout/new/Layout';
import Section1 from '../components/landing/Section1';
import Section2 from '../components/landing/Section2';
import Section3 from '../components/landing/Section3';
import Section4 from '../components/landing/Section4';
import Section5 from '../components/landing/Section5';
import Section6 from '../components/landing/Section6';
import Section7 from '../components/landing/Section7';

import useUser from '../store/user';

const Home = () => {
  const navigate = useNavigate();

  const { user } = useUser(
    useCallback(state => ({
      user: state.user,
    }))
  );

  useEffect(() => {
    if (user && !_.isEmpty(user)) {
      navigate('/dashboard');
    }
  }, [user]);

  return (
    <Layout transparent fixed loading={false}>
      <SectionContainer>
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        {/* <Section5 /> */}

        <Section7 />
        <Section6 />
      </SectionContainer>
    </Layout>
  );
};

export default Home;
